import React, { useState, useEffect } from "react";
import Grid from '@material-ui/core/Grid';
import { Paper, Box, Typography, Fade, Button } from '@material-ui/core';
import useStyles from './Styles/FolderStyles';
import placeholderImage from "../../../images/placeholderImage.jpg";
import PDFViewer from "../Staging/PDFViewer"
import FolderGrid from "./FolderGrid";
import DocumentGrid from "../Staging/DocumentGrid";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Divider from '@material-ui/core/Divider';
import notify from "../../../utils/notifier";
import DocuwareTemplateService from "../../../services/DocuwareTemplateService";
import DocumentTabularView from "../DocumentTabularView";
import PaginationRoot from "../PaginationRoot";
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useLocation } from "react-router-dom";



export default function FolderPage({ viewType, currentCompany }) {
    const classes = useStyles();
    const location = useLocation();
    const [documents, setDocuments] = useState([]);
    const [documentType, setDocumentType] = useState(null);
    const [types, setTypes] = useState([]);
    const [selectedDoc, setSelectedDoc] = useState(null);
    const [searchTriggered, setSearchTriggered] = useState(false);
    const [selectedDocuments, setSelectedDocuments] = useState(new Map());
    const [backdrop, setBackdrop] = useState(false);

    const [queryCount, setQueryCount] = useState(0);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = React.useState('desc');
    const [orderBy, setOrderBy] = React.useState('created_at');
    const [clientFields, setClientFields] = useState([]);
    const [selectedDocumentsFileId, setSelectedDocumentsFileId] = useState(new Set());



    const handleDocumentClick = (doc) => {
        setSelectedDoc((prevSelectedId) => (doc));
    };

    const handleSelectedDocs = (id, checked, fileIdentifier = null, name = null)  => {
        setSelectedDocuments(prev => {
            const newMap = new Map(prev);
            if (checked) {
              newMap.set(id, name || id);
            } else {
              newMap.delete(id);
            }
            return newMap;
          });

        if (fileIdentifier){
            setSelectedDocumentsFileId(prev => {
                const newSet = new Set(prev); 
                if (checked) {
                newSet.add(fileIdentifier);
                } else {
                newSet.delete(fileIdentifier); 
                }
                return newSet;
            });
        }
        
        
    }

    const fetchFolders = () => {

        DocuwareTemplateService.getAllTemplates(null).then(response => {
            let templateResponse = response.data;
            templateResponse = templateResponse ? templateResponse.documentTypes : [];
            templateResponse = templateResponse.filter(template => template.name !== 'other').map(template => (template.name));
            setTypes(templateResponse);
        }).catch(error => {
            notify({
                type: 'error',
                message: 'Error fetching the document types'
            });
        });

        DocuwareTemplateService.getClientFields().then(response => {
            let clientFieldResponse = response.data;
            // Filter out alias fields (fields with parentFieldId) - only show canonical fields
            clientFieldResponse = clientFieldResponse.filter(field => 
              !field.parentFieldId && !field.parent_field_id
            );
            setClientFields(clientFieldResponse);
        }).catch(error => {
            notify({
                type: 'error',
                message: 'Error fetching the field columns'
            });
        })
    }

    const handleRequestSort = property => event => {
        const isDesc = orderBy === property && order === "desc";
        setOrder(isDesc ? "asc" : "desc");
        setOrderBy(property);
        setPage(0);
        handleGetDocuments(rowsPerPage, 0, documentType, property, isDesc ? "asc" : "desc");
    };

    const handleFilterSearch = filters => {
        setPage(0);
        handleGetDocuments(rowsPerPage, 0, documentType, orderBy, order, filters);
    };

    useEffect(() => {
        fetchFolders();
        setDocuments([]);
        setSelectedDoc(null);
        setSearchTriggered(false);
        setDocumentType(null);
    }, [currentCompany]);

    const handleGetDocuments = (
        pageSize = rowsPerPage,
        currentPage = 0,
        template = documentType,
        sortBy = orderBy,
        sortOrder = order,
        filters = {}
    ) => {
        setBackdrop(true);
        const requestObj = {};
        setSelectedDocuments(new Set());
        setSelectedDocumentsFileId(new Set());

        let queryParams = {
            '_page': currentPage + 1,
            '_limit': pageSize,
        }

        if (template && template != '') {
            queryParams['_documentType'] = template.toLowerCase()
        }

        if (sortBy && sortOrder) {
            queryParams['_sort'] = sortBy;
            queryParams['_order'] = sortOrder;
        }

        if (filters) {
            queryParams = { ...queryParams, ...filters }
        }

        DocuwareTemplateService.searchDocuments(requestObj, queryParams).then(response => {
            let searchDocumentsResponse = response.data;
            let sampleDocuments = searchDocumentsResponse;


            let totalCount = response.headers['x-total-count'];
            if (!sampleDocuments.length) {
                notify({
                    type: "error",
                    message: "No documents are available for provided filters"
                });
            } else {
                setDocuments(sampleDocuments);
                setSearchTriggered(true);
                setSelectedDocuments(new Set());
                setSelectedDocumentsFileId(new Set());

                setQueryCount(totalCount);
            }
            setBackdrop(false);


        }).catch(error => {
            notify({
                type: 'error',
                message: 'Error Searching the documents'
            });
            setBackdrop(false);
        });
    };

    const handleFolderClick = (template) => {
        setDocumentType(template);
        handleGetDocuments(rowsPerPage, 0, template);
    };

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        handleGetDocuments(rowsPerPage, newPage, documentType);
    };

    const handleChangeRowsPerPage = event => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        handleGetDocuments(+event.target.value, 0, documentType);
    };

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const tab = queryParams.get("tab");
        const folderFromQuery = String(queryParams.get("folder") || "").trim();

        if (tab !== "folders" || !folderFromQuery) {
            return;
        }

        setDocumentType(folderFromQuery);
        handleGetDocuments(rowsPerPage, 0, folderFromQuery);
    }, [location.search, currentCompany]);

    return (
        <div style={{ marginTop: 9, height: 'calc(100vh - 64px)', maxWidth: '90vw', overflowX: 'hidden' }}>
            <Backdrop open={backdrop} style={{ color: "primary", zIndex: 1000000 }} >
                <CircularProgress color="inherit" />
            </Backdrop>
            {
                !searchTriggered && (
                    <Paper className={classes.root}>
                        <div >
                            <div >
                                <Grid item xs={12} md={12} style={{ height: '100%' }}>

                                    <Grid
                                        container
                                        spacing={3}
                                        justifyContent="flex-start"
                                        alignItems="stretch"
                                    >
                                        <FolderGrid
                                            documents={types}
                                            onDocumentClick={handleFolderClick}
                                            selectedDoc={documentType}
                                        />
                                    </Grid>

                                </Grid>
                            </div>


                        </div>
                    </Paper>
                )
            }
            {searchTriggered && (
                <>
                    <Paper className={classes.root_2} elevation={0} style={{ minHeight: '100vh', paddingBottom: 24 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 3, pt: 2, pb: 1 }}>
                            <Button
                                onClick={() => {
                                    setDocuments([]);
                                    setSelectedDoc(null);
                                    setSearchTriggered(false);
                                }}
                                startIcon={<ArrowBackIcon />}
                                className={classes.backButton}
                            >
                                Back to {documentType}
                            </Button>
                        </Box>
                        <Divider sx={{ mb: 2 }} />
                        <Grid container spacing={3} style={{ marginTop: 2, height: 'calc(100vh - 130px)' }}>
                            <Grid item xs={12} md={(selectedDoc && selectedDocuments && selectedDocuments.size <= 1) ? 6 : 12} style={{ height: '100%' }}>
                                <Fade in timeout={500}>
                                    <Paper
                                        style={{
                                            height: '100%',
                                            overflow: 'auto',
                                            padding: 28,
                                            boxSizing: 'border-box',
                                            background: viewType != 'grid' ? "#ffffff" : "#f8f8f8"
                                        }}
                                    >
                                        {viewType === 'grid' ?
                                            <div display='flex'>
                                                <Grid
                                                    container
                                                    spacing={3}
                                                    justifyContent="flex-start"
                                                    alignItems="stretch"
                                                >
                                                    <DocumentGrid
                                                        documents={documents}
                                                        placeholderImage={placeholderImage}
                                                        onDocumentClick={handleDocumentClick}
                                                        selectedDoc={selectedDoc}
                                                    />
                                                </Grid>
                                                <PaginationRoot
                                                    queryCount={queryCount}
                                                    page={page}
                                                    handleChangePage={handleChangePage}
                                                    rowsPerPage={rowsPerPage}
                                                    handleChangeRowsPerPage={handleChangeRowsPerPage} />
                                            </div>
                                            :
                                            <DocumentTabularView
                                                rows={documents}
                                                onDocumentClick={handleDocumentClick}
                                                orderBy={orderBy}
                                                order={order}
                                                queryCount={queryCount}
                                                page={page}
                                                handleChangePage={handleChangePage}
                                                rowsPerPage={rowsPerPage}
                                                handleChangeRowsPerPage={handleChangeRowsPerPage}
                                                handleMultipleFileSelect={handleSelectedDocs}
                                                selectedDocuments={selectedDocuments}
                                                selectedDocumentsFileId={selectedDocumentsFileId}
                                                setBackdrop={setBackdrop}
                                                clientFields={clientFields}
                                                handleRequestSort={handleRequestSort}
                                                handleFilterSearch={handleFilterSearch}
                                                documentTypes={[documentType]}
                                                allDocumentTypes={types}
                                            />}
                                    </Paper>
                                </Fade>
                            </Grid>
                            {(selectedDoc && selectedDocuments && selectedDocuments.size <= 1) && (
                                <Grid item xs={12} md={6} style={{ height: '100%' }}>
                                    <Paper
                                        elevation={3}
                                        style={{ height: '100%', padding: 16, overflow: 'auto', background: "#f8f8f8" }}
                                    >
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            mb={2} // margin bottom
                                        >
                                            <Typography variant="h6" noWrap>
                                                {documents.find((doc) => doc.id === selectedDoc)?.name}
                                            </Typography>
                                            <IconButton onClick={() => setSelectedDoc(null)}>
                                                <CloseIcon />
                                            </IconButton>
                                        </Box>
                                        <Fade in timeout={500}>

                                            <div
                                                style={{
                                                    height: '100%',
                                                    overflow: 'auto',
                                                    padding: 8,
                                                    background: '#f5f5f5',
                                                    borderRadius: 4,
                                                    boxSizing: 'border-box',
                                                }}
                                            >
                                                {/* {"provide fileurl to file here instead of path"} */}
                                                <PDFViewer file={selectedDoc.id} name={selectedDoc.name} extension={selectedDoc.extension} />
                                            </div>
                                        </Fade>
                                    </Paper>
                                </Grid>
                            )}
                        </Grid>
                    </Paper>

                </>
            )}
        </div>
    )
}